import React from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Title } from '~/components';
import { ConfirmButton } from '~/layouts/ksa/CompanyInfoLayout';
import paths from '~/pages/paths';
import styled from 'styled-components';
import colors from '~/constants/colors';

const GetStarted: React.FC = () => {
  const history = useHistory();

  const { t } = useTranslation('ksaOnboarding');
  const { t: tc } = useTranslation('common');

  const handleClick = () => {
    history.push(paths.home.application);
  };
  return (
    <>
      <Title text={t('Get started')} subtext={t('with {{BRANDING_NAME}}')} />
      <div>
        <p>{t('Excellent!')}</p>
        <p>
          {t(
            'Now we know a little bit more about you and your business, we can now move onto the full application process.'
          )}
        </p>
        <p>{t('This process should take no more than 30 minutes.')}</p>
        <p>
          {t(
            'You can also leave at any point and return by using the same email address you provided to us at the start.'
          )}
        </p>
      </div>
      <ConfirmButton id="letsStart" type="primary" onClick={handleClick}>
        {tc('Let’s start!')}
      </ConfirmButton>
      <Container>
        <p>{t('For successful completion, you will need the following documents:')}</p>
        <ul>
          <li>
            <b>{t('Commercial Registration')}</b>
          </li>
          <li>
            <b>{t('National ID ')}</b>
            {t('and documents of all partners in business')}
          </li>
          <li>
            <b>{t('Iqama ')}</b>
            {t('and passport copy of authorized signatory')}
          </li>
          <li>
            {t('Copy of ')}
            <b>{t('Bank account certificate ')}</b>
            {t('with stamp')}
          </li>
          <li>
            <b>{t('Legal power of attorney ')}</b>
            {t('(POA) of authorized person if applicable')}
          </li>
          <li>
            {t('Copy of Company’s ')}
            <b>{t('National Address')}</b>
          </li>
          <li>
            {t('Copy of ')}
            <b>{t('VAT Registration Certificate')}</b>
          </li>
        </ul>
      </Container>
    </>
  );
};

const Container = styled.div`
  margin-top: 32px;
  ul {
    padding: 0 25px;
  }
  p,
  ul > li {
    color: ${colors.grey[600]};
  }
`;

export default GetStarted;
